import './style/index.scss';
import App from './components/app';
import './env';
import './analytics/load';
import './globals/config';

export default App;
